module.exports = __webpack_public_path__ + "static/media/limited_offer.39945c06.svg";